import styled from '@emotion/styled';
import { lpPageColors, mainColors } from 'src/assets/colors';
import { fontSize, fontWeight } from 'src/assets/fonts-config';

import { RemoveTrashIcon } from 'src/assets/icons/RemoveTrashIcon';

interface HeroWidgetType {
    imgSrc?: string;
    isStart?: boolean;
    isEditLink?: boolean;
    homepage?: boolean;
}

export const Row = styled('div', { label: 'Row' })`
    padding: 5px 0;
`;

type ImageContainerType = Pick<HeroWidgetType, 'imgSrc'>;

export const ImageContainer = styled('div', { label: 'ImageContainer' })<ImageContainerType>`
    ${({ imgSrc }): string => imgSrc === undefined ? '' : `background-image: url(${imgSrc})`};
    background-size: cover;
    height: 168px;
    min-width: 176px;
`;

export const ContentContainer = styled('div', { label: 'ContentContainer' })`
    width: 100%;
    margin-left: 32px;
`;

export const CampaignName = styled('span', { label: 'CampaignName' })`
    color: ${mainColors.main.primary};
    font-size: ${fontSize.xRegular};
    font-weight: ${fontWeight.bold};
    line-height: 1.4;
    padding-bottom: 8px;
`;

export const CampaignNameValue = styled('span', { label: 'CampaignNameValue' })`
    color: ${mainColors.main.primary};
    font-size: ${fontSize.small};
    line-height: 1.2;
`;

export const DatesContainer = styled('div', { label: 'DatesContainer' })`
    display: flex;
`;

type DateWrapperType = Pick<HeroWidgetType, 'isStart'>;

export const DateWrapper = styled('div', { label: 'DateWrapper' })<DateWrapperType>`
    ${({ isStart }): string => isStart === true ? 'margin-right: 16px;' : ''};
`;

export const DateTitle = styled('div', { label: 'DateTitle' })`
    color: ${mainColors.grays.gray400};
    font-size: ${fontSize.small};
    line-height: 1.33;
`;

export const DateValue = styled('div', { label: 'DateValue' })`
    font-size: ${fontSize.xRegular};
    line-height: 1.2;
`;

export const TrashIconWrapper = styled(RemoveTrashIcon, { label: 'TrashIconWrapper' })`
    cursor: pointer;
    flex: 0 0 16px;
    margin-left: 8px;
    width: 16px;
`;

export const ActiveLabel = styled('span', { label: 'ActiveLabel' })`
    color: ${lpPageColors.activeLabel};
    font-size: ${fontSize.small};
    font-weight: ${fontWeight.bold};
    line-height: 1.3334;
    margin-left: 12px;
`;
